import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { Route } from '../Utils/Interfaces/Routes.interface';
import RouteList from '../Utils/Routes';

export const useRouteConfig = (): Route | null => {
  const location = useLocation();
  const routeConfig = useMemo(() => {
    const currentPath = location.pathname.replace(/\/+$/, '');
    return (
      Object.values(RouteList).find((route) => {
        /**
         * TODO: Should be refactored in scope of https://dev-mc.visualstudio.com/Minecraft/_workitems/edit/1269987
         * Current solution is a work around inconsistent fullPath as string\function at RouteList Config
         */
        if (typeof route.fullPath === 'function') {
          return currentPath.includes(route.path) || null;
        }

        return route.fullPath === currentPath;
      }) || null
    );
  }, [location.pathname]);

  return routeConfig;
};
